import { mapCommandCenterAnnouncements } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/announcements.utils';
import { brokerAnnouncementsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_ANNOUNCEMENTS_ACTION_TYPE = createNamedActions(
  'commandCenterAnnouncements',
  {
    SET_ANNOUNCEMENTS: 'SET_ANNOUNCEMENTS',
  },
);

export const getCommandCenterAnnouncementsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await brokerAnnouncementsApi.getAnnouncements({
    config: SKIP_FORBIDDEN_CONFIG,
  });

  return dispatch({
    type: COMMAND_CENTER_ANNOUNCEMENTS_ACTION_TYPE.SET_ANNOUNCEMENTS,
    payload: mapCommandCenterAnnouncements(data ?? null),
  });
});
